/**
 * Handle the showing and hiding of the "new delivery address" form
 */
export function checkout(toggleButton: HTMLButtonElement) {
    const deliveryAddressRadios = document.querySelectorAll('#js-delivery-locations input');
    const useNewAddressToggle = document.getElementById('js-new-delivery-location-toggle') as HTMLInputElement|null;
    const newDeliveryLocation = document.getElementById('js-new-delivery-location') as HTMLDivElement|null;

    if (useNewAddressToggle === null || newDeliveryLocation === null) {
        return;
    }

    if (!useNewAddressToggle.checked) {
        newDeliveryLocation.classList.add('d-none');
    }

    // show the "new delivery address" form
    toggleButton.addEventListener('click', () => {
        newDeliveryLocation.classList.remove('d-none');
        useNewAddressToggle.checked = true; // make sure validation triggers
        sessionStorage.setItem('useNewDeliveryLocation', '1')

        // unselect all the radios for existing delivery addresses
        for (let i = 0; i < deliveryAddressRadios.length; i++) {
            const dar = deliveryAddressRadios[i] as HTMLInputElement;
            dar.checked = false;
        }

        // if there's a text input (there should be) - focus it
        const firstInput = newDeliveryLocation.querySelector('input[type="text"]') as HTMLInputElement|null;
        if (firstInput !== null) {
            firstInput.focus();
        }
    }, false);

    for (let i = 0; i < deliveryAddressRadios.length; i++) {
        const dar = deliveryAddressRadios[i];
        // if clicking one of the existing delivery address radios, hide the "new delivery address" form
        dar.addEventListener('click', () => {
            newDeliveryLocation.classList.add('d-none');
            useNewAddressToggle.checked = false;
            sessionStorage.removeItem('useNewDeliveryLocation')
        }, false);
    }

}

export function preventDoubleSubmit(submitButton: HTMLButtonElement, loadingText: string) {
    const parentForm: HTMLFormElement|null = submitButton.closest('form');

    if (parentForm === null) {
        return;
    }

    parentForm.addEventListener('submit', () => {
        submitButton.disabled = true;
        submitButton.setAttribute('disabled', 'disabled');
        submitButton.classList.add('disabled', 'loading');

        submitButton.innerHTML = '<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> ' + loadingText;
    }, false);
}

export function saveOrderData(checkoutInputs: NodeListOf<HTMLInputElement>): void {
    checkoutInputs.forEach(input => {
        input.addEventListener('input', (event: InputEvent) => {
            if (event.target !== null && (<HTMLInputElement>event.target).value !== '') {
                sessionStorage.setItem(input.name, (<HTMLInputElement>event.target).value);
            }
        });
    });
}

export function loadOrderData(checkoutInputs: NodeListOf<HTMLInputElement>) {
    window.addEventListener('load', () => {
        const useNewAddressToggle = document.getElementById('js-new-delivery-location-toggle') as HTMLInputElement;
        const useNewDeliveryLocation = sessionStorage.getItem('useNewDeliveryLocation') === '1';
        const newDeliveryLocation = document.getElementById('js-new-delivery-location') as HTMLDivElement;

        if (useNewDeliveryLocation) {
            useNewAddressToggle.checked = true;
            newDeliveryLocation.classList.remove('d-none');
        }

        checkoutInputs.forEach(input => {
            let sessionData = sessionStorage.getItem(input.name);
            if (sessionData !== null) {
                if (input.type === 'text' || input.type === 'textarea' || input.type === 'select-one') {
                    input.value = sessionData
                    return;
                }

                if (input.value === sessionData && !useNewDeliveryLocation) {
                    input.checked = true;
                }

                return;
            }

            if (checkoutInputs.length === 1 && !useNewDeliveryLocation) {
                input.checked = true;
            }
        });
    });
}

export function clearOrderData(): void {
    const orderFields = [
        'deliveryLocation',
        'deliveryInstructions',
        'referenceNumber',
        'useNewDeliveryLocation',
        'newDeliveryLocation[name]',
        'newDeliveryLocation[addressLine1]',
        'newDeliveryLocation[addressLine2]',
        'newDeliveryLocation[town]',
        'newDeliveryLocation[county]',
        'newDeliveryLocation[postcode]',
        'newDeliveryLocation[country]',
    ];
    orderFields.forEach((orderField) => {
        sessionStorage.removeItem(orderField);
    });
}
